import React from 'react';
import WorkSection from './WorkSection'; // Adjust the import path as necessary

function WorkSectionsContainer({ sections, className }) {
    return (
        <>
            {sections.map((section, index) => (
                <WorkSection
                    key={"work_" + index}
                    id={"work_" + index}
                    {...section}
                    className={className}
                />
            ))}
        </>
    );
}

export default WorkSectionsContainer;